import { FaClock, FaEnvelope, FaMapMarkedAlt, FaPhoneAlt } from "react-icons/fa";

const contacts = [
    {
        id: 1,
        icon: <FaMapMarkedAlt />,
        title: "address",
        content: ["Sweet Delight Bakery, 15 Sugar Lane"],
    },
    {
        id: 2,
        icon: <FaPhoneAlt />,
        title: "call us",
        content: ["+111-222-333", "+123-456-7890"],
    },
    {
        id: 3,
        icon: <FaEnvelope />,
        title: "mail us",
        content: ["info@example.com", "xyz@gmail.com"],
    },
    {
        id: 4,
        icon: <FaClock />,
        title: 'opening hours',
        content: ["Mon - Fri: 08:00 am - 08:30 pm", "Sat - Sun: 10:00 am - 10:30 pm"],
    },
];

export default contacts;